import { takeLatest } from 'redux-saga/effects';
import { showSaga } from '../show/showSaga';
import { showPageSaga } from '../showPage/showPageSaga';
import {
  showSeasonSaga,
  submitApplicantsSaga,
} from '../showSeason/showSeasonSaga';
import { formStructureSaga } from '../formStructure/formStructureSaga';
import { getFaqSaga } from '../faq/faqSaga';
import { fileUploadSaga } from '../file/fileSaga';
import { getLocationSaga } from '../location/locationSaga';
import {
  getCountriesForSeasonSaga,
  onSeasonSaga,
} from '../country/countrySaga';

import * as showTypes from '../show/showActionTypes';
import * as showPageTypes from '../showPage/showPageActionTypes';
import * as showSeasonTypes from '../showSeason/showSeasonActionTypes';
import * as formStructureTypes from '../formStructure/formStructureActionTypes';
import * as faqTypes from '../faq/faqActionTypes';
import * as fileTypes from '../file/fileActionTypes';
import * as locationTypes from '../location/locationActionTypes';
import * as countryTypes from '../country/countryActionTypes';

export default function* CBSSaga() {
  yield takeLatest(showTypes.GET_SHOW_REQUEST, showSaga);
  yield takeLatest(showPageTypes.GET_SHOW_PAGE_REQUEST, showPageSaga);
  yield takeLatest(showSeasonTypes.GET_SHOW_SEASON_REQUEST, showSeasonSaga);
  yield takeLatest(
    showSeasonTypes.SUBMIT_APPLICANTS_REQUEST,
    submitApplicantsSaga
  );
  yield takeLatest(formStructureTypes.GET_FORM_REQUEST, formStructureSaga);
  yield takeLatest(faqTypes.GET_FAQ_REQUEST, getFaqSaga);
  yield takeLatest(fileTypes.UPLOAD_FILE_REQUEST, fileUploadSaga);
  yield takeLatest(locationTypes.GET_LOCATION_REQUEST, getLocationSaga);
  yield takeLatest(
    countryTypes.GET_COUNTRIES_REQUEST,
    getCountriesForSeasonSaga
  );
  yield takeLatest(showSeasonTypes.GET_SHOW_SEASON_SUCCESS, onSeasonSaga);
}



// WEBPACK FOOTER //
// ./src/store/sagas/index.js